const constants = {
    formname: "create_coupon"
}

export default constants